import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allPractices: [], // All combined/enriched practices
  crepResultLabel: [],
  loading: false, // Loading state for async UI feedback
};

const practiceSlice = createSlice({
  name: "practice",
  initialState,
  reducers: {
    setAllPractices: (state, action) => {
      state.allPractices = action.payload;
    },
    setCrepResultLabel(state, action) {
      state.crepResultLabel = action.payload;
    },
    setPracticeLoading: (state, action) => {
      state.loading = action.payload;
    },
    resetAllPractices:(state, action) => {
      state.allPractices = [];
    }
  },
});

export const { setAllPractices, setCrepResultLabel, setPracticeLoading, resetAllPractices } =
  practiceSlice.actions;

export default practiceSlice.reducer;
